import _slicedToArray from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// ignore-string-externalization
import React from 'react';
import { useRouter } from 'next/router';
import { Wait } from '../Layout/Wait';
import { NotFound } from '../Layout/NotFound';
import { useCurrentUser } from '../../@mrkt/useCurrentUser';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RequireFeatureFlag = function RequireFeatureFlag(_ref) {
  var flag = _ref.flag,
      children = _ref.children,
      redirectTo = _ref.redirectTo,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? /*#__PURE__*/_jsx(NotFound, {}) : _ref$fallback,
      _ref$waiting = _ref.waiting,
      waiting = _ref$waiting === void 0 ? /*#__PURE__*/_jsx(Wait, {}) : _ref$waiting,
      onPass = _ref.onPass,
      onFail = _ref.onFail;
  var router = useRouter();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showPage = _React$useState2[0],
      setShowPage = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      notFound = _React$useState4[0],
      setNotFound = _React$useState4[1];

  var user = useCurrentUser();
  React.useEffect(function () {
    if (user !== undefined) {
      if (flag !== null && (user === null || user === void 0 ? void 0 : user.username) !== 'frodormodules3') {
        setNotFound(true);
        onFail === null || onFail === void 0 ? void 0 : onFail();

        if (redirectTo) {
          router.push(redirectTo);
        }

        return;
      }

      onPass === null || onPass === void 0 ? void 0 : onPass();
      setShowPage(true);
    }
  }, [user]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showPage && children, !showPage && notFound && /*#__PURE__*/_jsx(_Fragment, {
      children: fallback
    }), !showPage && !notFound && /*#__PURE__*/_jsx(_Fragment, {
      children: waiting
    })]
  });
};